/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState, Fragment } from 'react';
import styled from 'styled-components';
import { IrDonorClaim } from 'shared/components/IrDonorClaim';
import { useIr, useNewFunderRating } from 'shared/apollo';
import Timeline from 'shared/components/ImpactReceipt/Timeline';
import Header from 'shared/components/ImpactReceipt/Header';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import numeral from 'numeral';
import toCamelCase from 'camelcase-keys';
import LegacyReportInfo from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackImpactReceipt/LegacyReportInfo';

export const ImpactReceiptMin = ({ investmentId, viewMode, noTabs }) => {
  const [data, setData] = useState({});
  const { data: query } = useIr(investmentId);
  const { run: runNew } = useNewFunderRating();

  useEffect(() => {
    if (query && query.report) {
      setData(query);
    }
  }, [query]);

  const isLegacy = data?.report?.is_legacy;

  const irReport = toCamelCase(data?.report, { deep: true });

  /*const handleOnPressRate = (
    value,
    reportId,
    funderRatingCategoryId,
    index,
    isSecond,
  ) => {
    const newData = { ...data };
    const newReport = { ...newData.report };
    const updateIndex = isSecond ? half + index : index;
    newReport.funder_rating_categories[updateIndex].current_value = `${value}`;
    runNew({ value, reportId, funderRatingCategoryId });
  };*/

  const report = data?.report;
  const donorsClaim = report?.donors_claim || [];
  const {
    cashAmount = 0,
    servicesAmount = 0,
    goodsAmount = 0,
    volunteerismAmount = 0,
    invested = 0,
  } = data ?? {};
  const budget =
    report?.total ??
    cashAmount + servicesAmount + goodsAmount + volunteerismAmount;
  const percent = budget ? ((invested * 100) / budget).toFixed(1) : 0;

  return (
    <Fragment>
      <Container className="top" color="#ebf0f6">
        <Col className="top">
          <Row>
            <span className="title">
              Impact Receipt <div className="r">®</div>
            </span>
          </Row>
        </Col>
        <Col>
          <Row>
            <Header {...{ data }} compact />
          </Row>
        </Col>
      </Container>
      <Container color="#ffffff">
        <Timeline {...{ data }} compact />
        <h2 style={{ marginTop: '24px' }}>Portion Contributed</h2>
        <Col>
          <Row>
            <ProgressContainer>
              <CircularProgressbar
                value={percent}
                text={`${percent}%`}
                styles={buildStyles({
                  strokeWidth: 32,
                  pathColor: '#62C660',
                  textColor: '#778BA5',
                  text: {
                    fontSize: '24px',
                    fontWeight: 'bold',
                  },
                })}
              />
              ;
            </ProgressContainer>
          </Row>
          <Row>
            <h3>Contribution:</h3>
            <h4>${numeral(invested).format('0,0')}</h4>
          </Row>
          <Row>
            <h3>Budget:</h3>
            <h4>${numeral(budget).format('0,0')}</h4>
          </Row>
        </Col>
        {donorsClaim && donorsClaim.length > 0 && (
          <Col>
            <Row>
              <IrDonorClaim data={donorsClaim} minified />
            </Row>
          </Col>
        )}
        {isLegacy && <LegacyReportInfo report={irReport} />}
      </Container>
    </Fragment>
  );
};

const ProgressContainer = styled.div`
  width: 100px;
  height: 100px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ color }) => color};
  padding: 10px;
  &.top {
    padding-top: 0px;
    padding-bottom: 20px;
  }
  h2 {
    color: #595959;
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-weight: 600;
    color: #595959;
    font-size: 16px;
  }
  h4 {
    font-weight: bold;
    font-size: 24px;
    color: #778ba5;
  }
  div.r {
    font-size: 16px;
    font-weight: 400px;
    color: #595959;
    display: inline-block;
    transform: translateY(-10px);
  }
`;

const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  &.top {
    padding-top: 0px;
    div {
      padding-top: 0px;
      span.title {
        font-size: 32px;
        font-weight: 400;
        color: #595959;
      }
    }
  }
`;

const Row = styled.div`
  flex: 1;
  padding: 10px;
  padding-bottom: 0px;
`;

const WipBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-color: #ffffff;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px;
  justify-content: center;
  align-items: center;
`;
